import React from 'react';
import { useTabsOrder } from '../hooks/useTabsOrder';
import { HeaderTabItem } from './HeaderTabItem';
import './HeaderTabs.scss';
export const HeaderTabs = ({ items }) => {
    const orderedItems = useTabsOrder(items);
    return (React.createElement("div", { className: "header-tabs" }, orderedItems.map(({ path, displayValue }) => (React.createElement(HeaderTabItem, { path: path, displayValue: displayValue })))));
};
//# sourceMappingURL=HeaderTabs.js.map